module.exports = __webpack_public_path__ + "static/media/21-jan24jan24.501ca4cf.pdf";